module.exports = __webpack_public_path__ + "img/video2.5d4c2965.webp";